import {
  MDBAutocomplete,
  MDBBtn,
  MDBInput,
  MDBModalFooter,
  MDBSelect,
  MDBSpinner,
} from "mdb-react-ui-kit";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { LocAddressSeach, add911Location, getMisc } from "../../../apiclients/streamsapi_bridge";
import { formattedNumber, validatePhoneNumber } from "../phonenumbers/AddRemoveNumbers";
import SeatLimitAlert from "../../../apiclients/SeatLimitAlert";
import { CANADA, USA } from "../../../components/images";
const AddNineOneOneLocation = forwardRef((props, ref) => {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const [freedids, setFreedids] = useState([]);
  const [billinggroups, setBillingGroups] = useState([]);
  // const [isloading, setIsloading] = useState(false);
  const [locationsList, setLocationsList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [addressReasults, setAddressReasults] = useState([]);
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const [Warningalert, setWarningalert] = useState("");



  const {
    register,
    setValue,
    formState,
    getValues,
    handleSubmit,
    setError,
    clearErrors,
    watch,
    control,
    reset,
  } = useForm({
    defaultValues: {
      nineoo_loc_name: "",
      street_addr1: "",
      street_addr2: "",
      city: "",
      state: 0,
      zip: "",
      billing_grp: 0,
      specific_location: "",
      dedicated_nine_one_one_number: "",
      primary_contact: {
        fname: "",
        lname: "",
        email: "",
        number: "",
      },
    },
  });
  const { errors, isDirty } = formState;
  const navigate = useNavigate();

  async function fetchData() {
    if (typeof props?.setSelect === "function") {
      props.setSelect();
    }

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["add_location"] }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    } else {
      //Need to discuss wheather we need to set the date here or not
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log(tdata);
    setFreedids(tdata?.misc?.add_location?.dedicated_nine_one_one_number ?? []);

    setBillingGroups(tdata?.misc?.add_location?.billing_grp ?? []);
    const transformedLocationsList = (
      tdata?.misc?.add_location?.state || []
    ).map((locations) => ({
      text: locations.statename,
      value: locations.stateid,
    }));
    setStateList(tdata?.misc?.add_location?.state || []);
    setLocationsList(transformedLocationsList);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const onsubmit = async (data) => {
    console.log("Preparing form data " + data);
    if (parseInt(data.state) === 0) {
      setError("state", {
        message: "Please Select a State",
      });
      return;

    }
    if (data.street_addr1 === "") {
      setError("street_addr1", {
        message: "Street Address is required",
      });
      return;

    }
    let updates = {};
    if (isDirty) {
      updates = {
        reqid: 56,
        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        nineoo_loc_name: data.nineoo_loc_name,
        street_addr1: data.street_addr1,
        street_addr2: data.street_addr2,
        city: data.city,
        state: parseInt(data.state),
        zip: data.zip,
        specific_location: data.specific_location,
        dedicated_nine_one_one_number: data.dedicated_nine_one_one_number,
        billing_grp: parseInt(data.billing_grp),
        primary_contact: {
          fname: data.primary_contact.fname,
          lname: data.primary_contact.lname,
          email: data.primary_contact.email,
          number: data.primary_contact.number,
        },
      };
    }
    if (typeof props?.setlocationName === "function") {
      props.setlocationName(updates?.nineoo_loc_name)
    }

    console.log("JSON Add 911 Location:: " + JSON.stringify(updates));
    // alert(JSON.stringify(updates));
    props.setIsloading(true);
    let saverep = await add911Location(updates);
    console.log(`reponse of Add 911 Location:::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log(
      `reponse of Add 911 Location after:::: ${JSON.stringify(saverepeMsg)}`
    );
    props.setIsloading(false);
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      props.setSuccessMessage(saverepeMsg.message);

      if (props.updatelocations) {
        props.updatelocations();
      }
      if (!props.removeFlag) {
        if (props.setAcdActive) {
          props.setAcdActive("location");
        }
      } else {
        if (typeof props?.setlocationName === "function") {
          props?.setlocationName(data.nineoo_loc_name);
        }
      }

      if (props.allLocation) {
        window.location.href = "/LocLanding"
      }

      if (props.setReRender) {
        props.setReRender(true);
        navigate("/LocLanding", {
          state: { tab: "location", tab1: "tab3" },
        });

      }

      props.onClose(updates.nineoo_loc_name);

      // window.location.href = "/loclanding";
    } else {
      if (saverepeMsg.message?.errors) {
        saverepeMsg.message.errors.forEach((err) => {
          setError(err.param_name, {
            type: "server",
            message: err.message,
          });
          const fieldElement = document.querySelector(
            `input[name="${err.param_name}"]`
          );
          if (fieldElement) {
            fieldElement.focus();
          }
        });
      } else {
        if (saverepeMsg.nineoo_profile_limit_exceed && saverepeMsg.nineoo_profile_limit_exceed !== "") {
          reset();
          setWarningalert(saverepeMsg.nineoo_profile_limit_exceed);
          setShowWarning(true);

        } else {

          localStorage.setItem("f_message", saverepeMsg.message);
          props.onClose();
          // props.setErrorMessage(saverepeMsg.message);
          navigate("/LocLanding", {
            state: { tab: "location", tab1: "tab3" },
          });

          window.location.reload();
        }
      }
    }
  };

  const billinggrpValidation = (value) => {
    if (value === 0) {
      return "Please Select the Billing Group";
    }
    return true;
  };


  const [typingTimeout, setTypingTimeout] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisplay, setisDisplay] = useState(false);
  const allowAPI = useRef(true);

  useEffect(() => {
    // Cleanup function to clear timeout when component unmounts or input value changes
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  function handleSearchAddressChange(searchValue) {
    try {
      clearErrors("street_addr1");
      setValue("street_addr1", searchValue, { shouldDirty: true });
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
      const newTimeout = setTimeout(() => {
        sendApIRequest(searchValue);
      }, 500);
      // Update the typingTimeout state with the new timeout
      setTypingTimeout(newTimeout);


    } catch (error) {
      console.log(`Error in 911 handleSearchAddressChange :::: ${error}`);

    }
  }

  const sendApIRequest = async (searchValue) => {
    try {
      if (searchValue.trim() !== "" && allowAPI.current) {
        //if (searchValue.trim() !== "") {
        let update = {
          reqid: 84,
          search: searchValue,
          siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        }
        setIsLoading(true);
        console.log("Request for the search :::::: " + JSON.stringify(update));
        const serverResponse = await LocAddressSeach(update);
        setIsLoading(false);
        if (!serverResponse.ok) {
          console.log("Network response was not ok");
          throw new Error('Network response was not ok');
        }
        else {
          const responseData = await serverResponse.json();
          console.log("Response Data:", JSON.stringify(responseData));
          let addressList = responseData?.message?.suggestions ?? [];
          setAddressReasults(addressList);
          if (addressList.length === 0) {
            setisDisplay(false);
          } else {
            setisDisplay(true);
          }
        }

      } else {
        allowAPI.current = true;
        setisDisplay(false);
      }



    } catch (error) {
      console.log(`Error in sendApIRequest for 911 address search :::: ${error}`);

    }

  }

  function handleAddressSelect(address) {
    if (address.street_line) {
      // setaddressValue(address.street_line);
      setValue("street_addr1", address.street_line, { shouldDirty: true });
    }
    if (address.secondary) {
      setValue("street_addr2", address.secondary, { shouldDirty: true });
    } else {
      setValue("street_addr2", "", { shouldDirty: true });
    }
    if (address.city) {
      setValue("city", address.city, { shouldDirty: true });
    }
    if (address.state) {
      const stateObj = stateList.find(state => state.statecode.trim() === address.state.trim());
      if (stateObj) {
        setValue("state", parseInt(stateObj.stateid), { shouldDirty: true });
      }
    }
    if (address.zipcode) {
      setValue("zip", address.zipcode, { shouldDirty: true });
    }


  }

  const handleOk = () => {
    warningToggle();
    props.onClose();
  }

  return (
    <>
      {/* {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )} */}
      <div>
        <div className="tel-numbers">
          <strong>{t("name")} *</strong>
        </div>
        <div className="form ">
          <MDBInput
            type="text"
            maxLength={50}
            className="w-100 mob-w-100"
            //value="jerome's Place"
            placeholder=""
            {...register("nineoo_loc_name", {
              required: "Name is required",
              // pattern: {
              //   value : /^[-a-zA-Z0-9_@.,;: ]{0,50}$/i,
              //   message: "The 911Location name is invalid. It must be up to 50 characters long and can only contain letters (A-Z, a-z), numbers (0-9), spaces and the special characters are _ - @ . , ; :"
              // },
            })}
          />
          {errors.nineoo_loc_name && (
            <p className="text-danger">{errors.nineoo_loc_name.message}</p>
          )}
        </div>
        <div className="tel-numbers mt-1">
          <strong>{t("StreetAddress")} *</strong>
        </div>
        <div className="form pt-1">
          <Controller
            name="street_addr1"
            control={control}
            rules={{ required: "Street Address 1 is required" }}
            render={({ field }) => (
              <MDBAutocomplete
                data={addressReasults}
                value={field.value}
                displayValue={(address) => address.street_line}
                isLoading={isLoading}
                // open={isDisplay}
                placeholder="Address 1"
                onSearch={handleSearchAddressChange}
                onSelect={(e) => {
                  allowAPI.current = false;
                  setisDisplay(false);
                }}
                onChange={(val) => field.onChange(val)}
                itemContent={(address) => (
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      allowAPI.current = false;
                      handleAddressSelect(address);
                      field.onChange(address.street_line); // update value
                    }}
                  >
                    {address.country &&
                      <img src={address.country === "USA" ? USA : CANADA} className='me-3' width={25} />
                    }
                    {address.street_line || ""}
                    {address.secondary ? ", " + address.secondary : ""}
                    {address.city ? ", " + address.city : ""}
                    {address.state ? ", " + address.state : ""}
                    {address.zipcode ? ", " + address.zipcode : ""}
                  </div>
                )}
              />
            )}
          />
          {errors.street_addr1 && (
            <p className="text-danger">{errors.street_addr1.message}</p>
          )}
        </div>
        <div className="form pt-1">
          <MDBInput
            type="text" placeholder='Address 2 (Optional)'
            className="form-control w-100"
            {...register("street_addr2")}
          />
          {errors.street_addr2 && (
            <p className="text-danger">{errors.street_addr2.message}</p>
          )}
        </div>
        <div className="tel-numbers mt-1">
          <strong>{t("City")} *</strong>
        </div>
        <div className="form pt-1">
          <MDBInput
            type="text"
            className="form-control w-100"
            //value="Grants Pass"
            {...register("city", {
              required: "City is required",
              setValueAs: (v) => v?.trim(),  // for trailing and leading space
              pattern: {
                value: /^[\w@.][\w@. ]{0,29}$/i,
                message: "Invalid City",
              },
            })}
          />
          {errors.city && <p className="text-danger">{errors.city.message}</p>}
        </div>

        <div className="row pt-3">
          <div className="col-6">
            <div className="tel-numbers">
              <strong>{t("State")} *</strong>
            </div>
            <div className="form">
              <Controller
                name="state"
                control={control}
                rules={{
                  validate: (value) => value !== 0 || "State is required",
                }}
                render={({ field }) => (
                  <MDBSelect
                    data={[
                      { text: "-- Select State --", value: 0 },
                      ...locationsList,
                    ]}
                    value={field.value}
                    search
                    onChange={(e) => {
                      field.onChange(e.value);
                    }}
                  />
                )}
              />
              {errors.state && (
                <p className="text-danger">{errors.state.message}</p>
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="tel-numbers">
              <strong>{t("ZIPCode")} *</strong>
            </div>
            <div className="form">
              <MDBInput
                type="text"
                //value="95727"
                className="w-100"
                {...register("zip", {
                  required: "ZIP Code is required",
                  setValueAs: (v) => v?.trim(), // for trailing and leading space
                  pattern: {
                    value: /^[\w-][\w- ]{0,19}$/i,
                    message: "Invalid ZIP Code",
                  },
                })}
              />
              {errors.zip && (
                <p className="text-danger">{errors.zip.message}</p>
              )}
            </div>
          </div>
        </div>

        <div className="tel-numbers mt-2">
          <strong>{t("Speclocation")}</strong>
        </div>
        <div className="form pt-1">
          <MDBInput
            type="text"
            className="form-control w-100"
            //value="Grants Pass"
            {...register("specific_location", {
              // required: "Specific Location is required",
              pattern: {
                value: /^[\w\.,&\/ -]{0,250}$/i,
                message: "Invalid Specific Location",
              },
            })}
          />
          {errors.specific_location && (
            <p className="text-danger">{errors.specific_location.message}</p>
          )}
        </div>

        <div className="tel-numbers mt-2">
          <strong>{t("PrimaryContact")}</strong>
        </div>
        <div className="row pt-2">
          <div className="col-6">
            <div className="tel-numbers fw-500">{t("firstName")} *</div>
            <div className="form">
              <MDBInput
                type="text"
                //value="Jerome"
                className="w-100"
                maxLength={30}
                {...register("primary_contact.fname", {
                  required: "First Name is required",
                  // pattern: {
                  //   value: /^([a-zA-Z])([_]*?[a-zA-Z0-9])*$/i,
                  //   message: "Invalid First Name",
                  // },
                })}
              />
              {errors.primary_contact?.fname && (
                <p className="text-danger">
                  {errors.primary_contact.fname.message}
                </p>
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="tel-numbers fw-500">{t("lastName")} *</div>
            <div className="form">
              <MDBInput
                type="text"
                maxLength={20}
                //value="Friesenhahn"
                className="w-100"
                {...register("primary_contact.lname", {
                  required: "Last Name is required",
                  // pattern: {
                  //   value: /^([a-zA-Z])([_]*?[a-zA-Z0-9])*$/i,
                  //   message: "Invalid Last Name",
                  // },
                })}
              />
              {errors.primary_contact?.lname && (
                <p className="text-danger">
                  {errors.primary_contact.lname.message}
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="tel-numbers mt-1">
          <strong>{t("email")} *</strong>
        </div>
        <div className="form pt-1">
          <MDBInput
            type="text"
            className="form-control w-100"
            //value="Jerome@panterranetworks.com "
            {...register("primary_contact.email", {
              setValueAs: (v) => v?.trim(), 
              required: "Email is required",
              pattern: {
                value:
                  /^[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/i,
                message: "Invalid Email",
              },
            })}
          />
          {errors.primary_contact?.email && (
            <p className="text-danger">
              {errors.primary_contact.email.message}
            </p>
          )}
        </div>
        {/* <div className="tel-numbers mt-1">
          <strong>{t("Number")}</strong>
        </div>
        <div className="form pt-1">
          <MDBInput
            type="text"
            className="form-control w-100"
            //value="541 856 9547"
            {...register("primary_contact.number", {
              required: "Number is required",
              validate: validatePhoneNumber,
              pattern: {
                value: /^[0-9]{10,16}$/i,
                message: "Invalid Number",
              },
            })}
          />
          {errors.primary_contact?.number && (
            <p className="text-danger">
              {errors.primary_contact.number.message}
            </p>
          )}
        </div> */}
        <div className="routing-border my-2"> </div>
        <div className="tel-numbers mt-1">
          <strong>{t("dedicate911no")} *</strong>
        </div>
        <select
          className="form-select  form-control w-100"
          name="San Jose"
          {...register("dedicated_nine_one_one_number", {
            required: "Please Select a Dedicated Number for 911",
            pattern: {
              value: /^[0-9]{10,16}$/i,
              message: "Invalid Dedicated 911 number for this location",
            },
          })}
        //onChange={(e) => changeNumber(e)}
        >
          <option value={""} selected>
            --Select a Dedicated Number for 911--
          </option>

          {freedids &&
            Object.entries(freedids).map(([key, value]) => (
              <option value={key}>{formattedNumber(value)}</option>
            ))}
        </select>
        {errors.dedicated_nine_one_one_number && (
          <p className="text-danger">
            {errors.dedicated_nine_one_one_number.message}
          </p>
        )}
        <div className="tel-numbers mt-1">
          <strong>{t("billingGroup")} *</strong>
        </div>
        <select
          className="form-select form-control w-100 mb-3"
          name="San Jose"
          {...register("billing_grp", {
            validate: billinggrpValidation,
          })}
        >
          <option value={0} selected>
            ---- Select Billing Group ----
          </option>
          {billinggroups &&
            billinggroups.map((item) => (
              <>
                <option value={item.groupid}>{item.groupname}</option>
              </>
            ))}
        </select>
        {errors.billing_grp && (
          <p className="text-danger">{errors.billing_grp.message}</p>
        )}
      </div>
      <div style={{ display: "none" }}>
        <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(onsubmit)() }}>
          {t("add")}</button>
      </div>

      {showWarning && (
        <SeatLimitAlert
          warningToggle={warningToggle}
          setShowWarning={setShowWarning}
          warningMessage={Warningalert}
          onOk={handleOk}
        />
      )}

      {/* <MDBModalFooter>
        <MDBBtn onClick={(e) => props.onClose(e)} color="secondary">
          {t("close")}
        </MDBBtn>
        <MDBBtn
          onClick={(e) => {
            e.preventDefault();
            handleSubmit(onsubmit)();
          }}
          color="primary"
        >
          {t("add")}
        </MDBBtn>
      </MDBModalFooter> */}
    </>
  );
});
export default AddNineOneOneLocation;
